import React from 'react';
// import {StrictMode} from 'react';
//import ReactDOM from 'react-dom'; //React v18から未使用
// import ReactDOM from 'react-dom/client'; //React v18から使用
import { createRoot }  from 'react-dom/client'; //React v18から使用
//import { BrowserRouter } from "react-router-dom";
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import firebase from'firebase/compat/app';
import 'firebase/compat/analytics';

const firebaseConfig = {
  apiKey: "AIzaSyA4L0L4cUZWDxvWCaf0iP1QBpVRhqpa1nE",
  authDomain: "famikar-app.firebaseapp.com",
  databaseURL: "https://famikar-app.firebaseio.com",
  projectId: "famikar-app",
  storageBucket: "famikar-app.appspot.com",
  messagingSenderId: "748448731",
  appId: "1:748448731:web:38f81b0d726e9994b295fe",
  measurementId: "G-489RZD6GH7"
};

// const firebaseDevConfig = {
//   apiKey: "AIzaSyCyt_mbTzyWqOX0dIy-wNGpES_4cUD-PVw",
//   authDomain: "dev-app.famikar.jp",
//   projectId: "dev-famikar-app",
//   storageBucket: "dev-famikar-app.firebasestorage.app",
//   messagingSenderId: "775638622841",
//   appId: "1:775638622841:web:d5649824392966e80deaa8",
//   measurementId: "G-0BB720GHS0"
// };

firebase.initializeApp(firebaseConfig);
// firebase.initializeApp(firebaseDevConfig);
firebase.analytics();

const container = document.getElementById('root')
const root = createRoot(container)
root.render(
  // <StrictMode>
    <App />
  // </StrictMode>
) //React v18から使用


//ReactDOM.render(<App />, document.getElementById('root')); //React v18から未使用

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
